module.exports = {
  colors: {
    purple: '#004132',
    green: '#00af55',
    gray: '#454550',
    orange: '#EC6E16',
    yellow: '#F3B700',
    white: '#FFFFFF',
    ghostWhite: '#f9f9f9',
    raisinBlack: '#202020',
    philippineGray: '#8b8b92',
    venetianRed: '#f44336',
    'display-500': '#919dab',
  },
};
